import { ChainId } from '@babydogeswap/sdk'
import { BabydogeCollectionKey, BabydogeCollections } from '../types'

export const babydogeCollections: BabydogeCollections = {
  [BabydogeCollectionKey.BABYDOGE]: {
    name: 'BabyDoge Doggies',
    slug: 'babydoge-doggies',
    address: {
      [ChainId.MAINNET]: '0x7257E66B830441A9300e8ece6b8b1649e04016Ef',
      [ChainId.TESTNET]: '0x9f22bF4Ac6a2Ca148bFC15090F05936C220775Ad'
    }
  }
}
